import { render } from "./UiSettingsSection.vue?vue&type=template&id=1196850e&ts=true"
import script from "./UiSettingsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiSettingsSection.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiSettingsSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1196850e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1196850e', __exports__)) {
    api.reload('1196850e', __exports__)
  }
  
  module.hot.accept("./UiSettingsSection.vue?vue&type=template&id=1196850e&ts=true", () => {
    api.rerender('1196850e', render)
  })

}


export default __exports__